"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReportRunMessage = exports.getFilterUpdatePostMessage = exports.getEmbedReportUri = void 0;
const reportElementTypes_1 = require("../../domain/reportElementTypes");
const dashboard_1 = require("./dashboard");
const look_1 = require("./look");
const getEmbedReportUri = async (embeddedReportId, reportType, selectedSiteIds) => {
    switch (reportType) {
        case reportElementTypes_1.ReportElementTypes.Dashboard:
            return await (0, dashboard_1.getEmbedUriForDashboard)(embeddedReportId, selectedSiteIds);
        case reportElementTypes_1.ReportElementTypes.Look:
            return await (0, look_1.getEmbedUriForLook)(embeddedReportId);
        default:
            return '';
    }
};
exports.getEmbedReportUri = getEmbedReportUri;
const getFilterUpdatePostMessage = (reportType, selectedSiteIds) => {
    switch (reportType) {
        case reportElementTypes_1.ReportElementTypes.Dashboard:
            return JSON.stringify({
                type: 'dashboard:filters:update',
                filters: {
                    Site: selectedSiteIds?.join(','),
                },
            });
        case reportElementTypes_1.ReportElementTypes.Look:
            return JSON.stringify({
                type: 'look:filters:update',
                filters: {
                    'sites.id': selectedSiteIds?.join(','),
                },
            });
        default:
            return '';
    }
};
exports.getFilterUpdatePostMessage = getFilterUpdatePostMessage;
const getReportRunMessage = (reportType) => {
    switch (reportType) {
        case reportElementTypes_1.ReportElementTypes.Dashboard:
            return JSON.stringify({
                type: 'dashboard:run',
            });
        case reportElementTypes_1.ReportElementTypes.Look:
            return JSON.stringify({
                type: 'look:run',
            });
        default:
            return '';
    }
};
exports.getReportRunMessage = getReportRunMessage;
